import widgetDataTypes from './widgetDataTypes'

export default {
    [widgetDataTypes.LINES_TYPE_ID]: 'RedesignTimeLineChart',
    [widgetDataTypes.BARS_WITH_LINES_TYPE_ID]: 'RedesignTimeLineChart',
    [widgetDataTypes.X_AXIS_TYPE_ID]: 'RedesignXaxisChart',
    [widgetDataTypes.TABLE_TYPE_ID]: 'RedesignTableData',
    [widgetDataTypes.COUNTER_TYPE_ID]: 'RedesignCounterCard',
    [widgetDataTypes.CHART_SPEEDOMETER]: 'GaugeChart',
    [widgetDataTypes.CHART_QUEUE]: 'RedesignQueueChart',
    [widgetDataTypes.HISTORY_COUNTERS]: 'StatisticsCards', // we don`t have any template for it yet
    [widgetDataTypes.QUEUE_DASHBOARD]: 'RedesignQueueDashboard',
    [widgetDataTypes.QUEUE_COUNTER_TYPE_ID]: 'RedesignQueueCounterCard',
    [widgetDataTypes.QUEUE_ACTIVE_CALL]: 'QueueActiveCall',
    [widgetDataTypes.EXTERNAL_DATA_TYPE_ID]: 'ExternalDataWidget',
    [widgetDataTypes.PIE_TYPE_ID]: 'RedesignPieChart',
    [widgetDataTypes.RICH_TEXT_EDITOR_ID]: 'RichTextEditor',
    [widgetDataTypes.TOTAL_OUTGOING_CALLS]: 'RedesignTotalOutgoingCalls',
    [widgetDataTypes.CHART_AREA_ID]: 'RedesignAreaChart',
    [widgetDataTypes.RICH_TEXT_EDITOR_LIST]: 'RichTextListEditor',
    [widgetDataTypes.AVERAGE_CALLS_DURATION]: 'RedesignAvgCallDuration',
    [widgetDataTypes.FUNNEL_3D_TYPE_ID]: 'RedesignFunnel3DChart',
    [widgetDataTypes.DIALERS_TYPE_ID]: 'RedesignTableData',
    [widgetDataTypes.INFO_TYPE_ID]: 'SocketsRealTimeFunnel',
    [widgetDataTypes.BAR_LINE_TYPE_ID]: 'RedesignBarLineChart',
    [widgetDataTypes.EXTENSION_CARDS_STATISTICS]: 'RedesignExtensionCards',
    [widgetDataTypes.POLAR_CHART_TYPE_ID]: 'RedesignBaseDataLoadChart',
    [widgetDataTypes.HEATMAP_CHART_TYPE_ID]: 'RedesignBaseDataLoadChart',
    [widgetDataTypes.EXTENSIONS_DASHBOARD]: 'ExtensionsDashboard',
    [widgetDataTypes.VOICEBOTS_DASHBOARD]: 'VoicebotsWidget',
    [widgetDataTypes.CLOCK_AND_DATE_TYPE_ID]: 'ClockAndDateWidget',
    [widgetDataTypes.AI_SUMMARY_TEXT]: 'RedesignAiSummarySimpleText',
    [widgetDataTypes.AI_SUMMARY_BULLETS_LIST]: 'RedesignAiSummaryBullets',
    [widgetDataTypes.AI_SUMMARY_NUMBERS_LIST]: 'RedesignAiSummaryNumbers',
    [widgetDataTypes.VOICEBOT_COUNTER_TYPE_ID]: 'VoicebotCounterCard',
    [widgetDataTypes.AI_COUNTER_TYPE_ID]: 'AiCounterCard'
}
